<template>
  <div>
    <vue-headful title="Reset Password" />
    <Header page_title="Reset Password" />
    <div class="d-flex min-height align-items-center">
      <div class="container-fluid px-4 mx-2">
        <form class="mt-5" @submit.prevent="onSubmit">
          <p>Please enter your new password.</p>
          <div
            class="alert alert-danger alert-dismissible fade show mb-4"
            role="alert"
            v-if="$data.error && !$data.success"
          >
            <strong v-if="$data.error.message">{{
              $data.error.message
            }}</strong>
            <ul class="list-unstyled mb-0" v-if="$data.error.errors">
              <li v-for="(value, key) in $data.error.errors" v-bind:key="key">
                <strong>{{ value[0] }}</strong>
              </li>
            </ul>
            <button
              type="button"
              class="close"
              data-dismiss="alert"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div
            class="alert alert-success alert-dismissible fade show mb-3"
            role="alert"
            v-if="$data.success"
          >
            <strong>{{ $data.success.message }}</strong>
            <button
              type="button"
              class="close"
              data-dismiss="alert"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="form-group w-square-icon">
            <input
              v-model="form.password"
              v-bind:type="[!pass1 ? 'text' : 'password']"
              class="form-control"
              placeholder="Wachtwoord"
              autocomplete="nope"
              required
            />
            <div
              class="icon-wrapper eye position-absolute align-self-center"
              v-on:click="pass1 = false"
              v-if="pass1"
            >
              <i class="material-icons">remove_red_eye</i>
            </div>
            <div
              class="icon-wrapper eye shown position-absolute align-self-center"
              v-on:click="pass1 = true"
              v-else
            >
              <i class="material-icons">visibility_off</i>
            </div>
          </div>
          <div class="form-group w-square-icon">
            <input
              v-model="form.password_confirmation"
              v-bind:type="[!pass2 ? 'text' : 'password']"
              class="form-control"
              placeholder="Bevestig wachtwoord"
              autocomplete="nope"
              required
            />

            <div
              class="icon-wrapper eye position-absolute align-self-center"
              v-on:click="pass2 = false"
              v-if="pass2"
              v-ripple="'rgba(255, 255, 255, 0.35)'"
            >
              <i class="material-icons">remove_red_eye</i>
            </div>
            <div
              class="icon-wrapper eye shown position-absolute align-self-center"
              v-on:click="pass2 = true"
              v-else
              v-ripple="'rgba(255, 255, 255, 0.35)'"
            >
              <i class="material-icons">visibility_off</i>
            </div>
          </div>
          <button type="submit" class="btn btn-warning btn-block">
            Change password
          </button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: function() {
    return {
      form: {
        password: "",
        password_confirmation: ""
      },
      pass1: true,
      pass2: true,
      success: false,
      error: false
    };
  },
  created() {
    // fetch the data when the view is created and the data is
    // already being observed
    this.fetchData();
  },
  watch: {
    // call again the method if the route changes
    $route: "fetchData"
  },
  methods: {
    fetchData() {
      // do whatever
      // check if the token matches
      // disable direct access on this page
    },
    onSubmit: function() {
      if (this.form.password === this.form.password_confirmation) {
        // loading
        // api process here
      } else {
        this.error = Object.assign({}, { message: "Passwords doesn't match." });
      }
    }
  }
};
</script>

<style scoped></style>
